import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Field, ButtonComponent, InputCheckboxComponent } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { Subscription } from 'rxjs';
import { globalConstants } from '../global-constants';

@Component({
    selector: 'app-cc-payment-confirmation',
    templateUrl: './cc-payment-confirmation.component.html',
    styleUrls: ['./cc-payment-confirmation.component.scss'],
    imports: [CommonModule, FormsModule, ButtonComponent, InputCheckboxComponent],
    encapsulation: ViewEncapsulation.None
})
export class CCPaymentConfirmationComponent implements OnInit, OnDestroy {
    isMobile: boolean;
    private sink = new Subscription();
    pageDetails: any;
    checkValue = false;
    paymentAcknowledgementField: any;

    displayStatement1: string = '';
    displayStatement2: string = '';
    paymentConfirmationText: string = '';

    constructor(
        public dialogRef: MatDialogRef<CCPaymentConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');
        this.sink.add(
            this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
                this.isMobile = result.matches;
            })
        );
    }

    ngOnInit(): void {
        this.pageDetails = this.data.paymentDetails;
        this.displayStatement1 = globalConstants.displayStatement1.replace('{processingFee}', this.pageDetails.processingFee);
        if (this.pageDetails.state === 'CT') {
            this.displayStatement2 = globalConstants.displayStatement_CT.replace('{totalDue}', this.pageDetails.dueToday);
        } else {
            this.displayStatement2 = globalConstants.displayStatement_Other.replace('{totalDue}', this.pageDetails.dueToday);
        }
        this.paymentConfirmationText = globalConstants.paymentAcknowledgement.replace('{processingFee}', this.pageDetails.processingFee);

        this.paymentAcknowledgementField = new Field({
            name: 'paymentAcknowledgementField',
            id: 'paymentAcknowledgementField',
            description: this.paymentConfirmationText,
            value: false,
            required: true,
        });
    }

    pageNavigation($event: any) {
        if ($event === 'goBack') {
            this.dialogRef.close();
        } else if ($event === 'continue') {
            this.onOk();
        }
    }

    onOk(): void {
        this.dialogRef.close(this.checkValue);
    }

    ngOnDestroy(): void {
        this.sink.unsubscribe();
    }
}
